export { default } from './Image';
export type { ImageProps, ImageClassKey, ImageClasses } from './Image.types';
